module.exports = __webpack_public_path__ + "static/img/man_glove_5.e6068dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/man_glove_5.png
// module id = c7rJ
// module chunks = 0